import { render, staticRenderFns } from "./ZGGalleries.vue?vue&type=template&id=4a4dcd8e&scoped=true"
import script from "./ZGGalleries.vue?vue&type=script&lang=js"
export * from "./ZGGalleries.vue?vue&type=script&lang=js"
import style0 from "./ZGGalleries.vue?vue&type=style&index=0&id=4a4dcd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4dcd8e",
  null
  
)

export default component.exports